import { postApi } from '../api/digitalVault';
import { parseUserResponse } from '../utils';
export default async (repository, fileName, size, checksum, parentPath, file, contentTokens, systemAttribute, configParams, uploadConfig, addTimezoneHeader, logger) => {
    const query = new URLSearchParams();
    const headers = {};
    Intl.DateTimeFormat().resolvedOptions &&
        Intl.DateTimeFormat().resolvedOptions().timeZone &&
        addTimezoneHeader &&
        (headers['X-Vault-Client-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (configParams) {
        const paramKeys = Object.keys(configParams);
        paramKeys.forEach((item) => query.append(item, String(configParams[item])));
    }
    const jsonText = {
        files: {
            '@xmlns': {
                dvi: 'http://internal.dv.newbay.com/ns/1.0',
                $: 'http://dv.newbay.com/ns/1.0',
                a: 'http://alternate.newbay.com/ns/1.0',
            },
            file: {
                name: {
                    $: `${fileName}`,
                },
                parentPath: {
                    $: `${parentPath}`,
                },
                size: {
                    $: `${size}`,
                },
                checksum: {
                    $: `${checksum}`,
                },
            },
        },
    };
    if (contentTokens && contentTokens.length > 0) {
        const fileData = jsonText.files.file;
        fileData.contentToken = {
            $: `${contentTokens.join(',')}`,
        };
        jsonText.files.file = fileData;
    }
    if (systemAttribute && systemAttribute.length > 0) {
        jsonText.files.file.systemAttribute =
            systemAttribute.length > 1 ? systemAttribute : systemAttribute[0];
    }
    const jsonBlob = new Blob([JSON.stringify(jsonText)], { type: 'text/json' });
    const jsonFile = new File([jsonBlob], 'files', { type: 'application/vnd.newbay.dv-1.27+json' });
    const formData = new FormData();
    formData.append('files', jsonFile);
    if (file) {
        formData.append(checksum, file);
    }
    const result = await postApi(formData, `repository/${repository}/file?${query.toString()}`, headers, logger);
    if (result.files) {
        return parseUserResponse(undefined, result.files, () => false);
    }
    return result;
};
